import { Box, Typography, makeStyles, Grid } from '@material-ui/core';
import { TickCircle } from 'iconsax-react';

const useStyles = makeStyles(() => ({
	root: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	title: {
		fontSize: '14px',
		fontWeight: 700,
		color: '#000000',
	},
	subTitlePayment: {
		fontSize: '12px',
		fontWeight: 700,
		color: '#14AC88',
	},
	price: {
		fontSize: '18px',
		fontWeight: 700,
		color: '#101740',
		display: 'flex',
		alignItems: 'center',
	},
}));

const TickRow = (props) => {
	const classes = useStyles();
	const { title, payment, price, start, end, subtitle ,colorTitle} = props;
	return (
		<Grid container className={classes.root}>
			<Grid item xs={7}>
				<Grid container style={{ display: 'flex', alignItems: 'center' }}>
					{payment && <TickCircle size="24" color="#14AC88" style={{ marginLeft: '8px' }} />}
					<Box>
						<Typography className={classes.title} {... (colorTitle && {style:{color:colorTitle}})} >{title}</Typography>
						{payment === true && subtitle && (
							<Typography style={{ color: '#14AC88' }} className={classes.subTitlePayment}>
								قسط {start} از {end} پرداخت شده
							</Typography>
						)}
						{subtitle && (
							<Typography style={{ color: '#888BA0' }} className={classes.subTitlePayment}>
								قسط {start} از {end}
							</Typography>
						)}
					</Box>
				</Grid>
			</Grid>
			<Grid item xs={3}>
				<Grid container style={{ display: 'flex', justifyContent: 'flex-end' }}>
					<Typography className={classes.price}>
						{price}{' '}
						<Typography style={{ fontSize: '15px', fontWeight: 500, color: '#101740', marginRight: '4px' }}>
							تومان
						</Typography>
					</Typography>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default TickRow;
